import styled, { css } from 'styled-components';
import { Modal } from '@/components/Modal';
import { ScModalBg } from '@/components/Modal/styled';
import { ScTermsAndConditionsList } from '../../../../components/TermsAndConditionsList/styled';
import { fpx } from '../../../../styles/fluid';
import { halloweenScale } from '../../styled';

export const ScTermsModal = styled(Modal)`
  ${halloweenScale};
  font-family: "Work Sans", sans-serif;

  ${ScModalBg} {
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
  }
`;

export const ScOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: ${fpx(110)} 0;
`;

export const ScDialog = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${fpx(409)};

  @media (orientation: portrait) {
    width: ${fpx(299)};
    padding: 0 ${fpx(13)};
  }
`;

export const ScDialogBackground = styled.div`
  position: absolute;
  z-index: -1;
  top: ${fpx(-71.6)};
  left: ${fpx(-100.4)};
  width: ${fpx(570.2)};
  height: ${fpx(522.1)};
  pointer-events: none;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  @media (orientation: portrait) {
    top: ${fpx(-43)};
    left: ${fpx(-40)};
    width: ${fpx(361)};
    height: ${fpx(393)};
  }
`;

interface IShadowBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

export const ScDialogShadow = styled.span<{
  $desktop: IShadowBox;
  $mobile?: Pick<IShadowBox, 'x' | 'y'>;
}>`
  position: absolute;
  z-index: -1;
  top: ${({ $desktop }) => fpx($desktop.y)};
  left: ${({ $desktop }) => fpx($desktop.x)};
  width: ${({ $desktop }) => fpx($desktop.width)};
  height: ${({ $desktop }) => fpx($desktop.height)};
  border-radius: 999px;
  background: #000;
  filter: blur(${fpx(10)});
  pointer-events: none;

  @media (orientation: portrait) {
    ${({ $mobile }) =>
      $mobile
        ? css`
            top: ${fpx($mobile.y)};
            left: ${fpx($mobile.x)};
          `
        : css`
            display: none;
          `}
  }
`;

export const ScTermsTitle = styled.h2`
  margin: 0 0 ${fpx(12)};
  background-image: linear-gradient(90deg, #ff7b00, #ffcb00);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  font-size: ${fpx(22)};
  font-weight: 700;
  line-height: ${fpx(28)};
  letter-spacing: 0.44px;
  white-space: nowrap;

  @media (orientation: portrait) {
    margin-bottom: ${fpx(6)};
    font-size: ${fpx(18)};
  }
`;

const FADE_MASK = 'linear-gradient(180deg, #000 calc(100% - 3em), transparent)';

export const ScTermsScroll = styled.div<{ $isFaded: boolean }>`
  width: 100%;
  height: ${fpx(268)};
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${({ $isFaded }) =>
    $isFaded &&
    css`
      mask-image: ${FADE_MASK};
      -webkit-mask-image: ${FADE_MASK};
    `}

  ${ScTermsAndConditionsList} {
    max-width: none;
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-size: ${fpx(16)};
    font-weight: 400;
    line-height: normal;
    text-shadow: 0 4px 4px #000;

    .terms-content ol {
      margin: 0;
      padding: 0;

      li:not(:last-child) {
        margin-bottom: ${fpx(12)};
      }
    }
  }

  @media (orientation: portrait) {
    height: ${fpx(222)};

    ${ScTermsAndConditionsList} {
      font-size: ${fpx(14)};

      .terms-content ol li:not(:last-child) {
        margin-bottom: ${fpx(8)};
      }
    }
  }
`;

// Figma draws the indicator over the text, so the native scrollbar (which takes layout width) is hidden.
export const ScScrollThumb = styled.span`
  position: absolute;
  top: ${fpx(45)};
  left: ${fpx(397)};
  width: ${fpx(5)};
  height: ${fpx(95)};
  border-radius: ${fpx(8)};
  background: #8e8e93;
  transform: translateY(calc(var(--scroll-progress, 0) * ${fpx(163)}));
  pointer-events: none;

  @media (orientation: portrait) {
    top: ${fpx(38)};
    left: ${fpx(283)};
    transform: translateY(calc(var(--scroll-progress, 0) * ${fpx(119)}));
  }
`;

export const ScCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${fpx(325)};
  height: ${fpx(40)};
  margin-top: ${fpx(24)};
  padding: 0 ${fpx(16)};
  border: 0;
  border-radius: ${fpx(12)};
  background: #ea5b0c;
  color: #fff;
  font-family: inherit;
  font-size: ${fpx(16)};
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  cursor: pointer;
  transition: opacity 0.2s ease;

  @media (hover: hover) {
    &:hover {
      opacity: 0.8;
    }
  }

  @media (orientation: portrait) {
    width: ${fpx(241)};
    margin-top: ${fpx(9)};
    font-size: ${fpx(14)};
  }
`;
